






























import Vue from 'vue';

import Accordion from "./Accordion.vue"
import JourneySummary from './JourneySummary.vue'
import {Component, Prop} from "vue-property-decorator";
import {IRefundStatusJourney} from "./IRefundStatusJourney";
import {CrsConverter} from "./CrsConverter";
import {IJourneyDetails} from "./JourneyDetails";
import RefundWarning from "./RefundWarning.vue";
import InstantRefundOffer from "./InstantRefundOffer.vue";
import Modal from "./Modal.vue";
import AppealsEmail from "./AppealsEmail.vue";
import {IRefundSuccess} from "./IRefundSuccess";

@Component({
    components: {
        AppealsEmail,
        RefundWarning,
        InstantRefundOffer,
        JourneySummary,
        Accordion,
        Modal
    }
})
export default class InstantRefundNoReplacement extends Vue {
    @Prop() refundStatus: IRefundStatusJourney;
    @Prop() details: IJourneyDetails;
    @Prop() crsConverter: CrsConverter;
    @Prop() currencyFormatter: Intl.NumberFormat;
    @Prop() appealsEmail: string;
    @Prop() canAppeal: boolean;
    @Prop() dryRunRefund: IRefundSuccess;

    appealModalVisible: boolean = false;
}
